import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import Layout from './Components/DefaultLayout/Layout/layout.js'
import Login from './Views/Page/Login/login'
import SignUp from './Views/Page/Register/register'
import SendEmail from './Views/Page/ForgetPassword/sendEmail/sendEmail'
import ResetPass from './Views/Page/ForgetPassword/Forget/forget'

class App extends Component {
  render() {
    if (this.props.lang === "ar") {
      document.body.style.direction = "ltr";
      document.body.style.textAlign = "left";
      document.body.style.marginRight = "0px";
    } else {
      document.body.style.direction = "rtl";
      document.body.style.textAlign = "right";
      document.body.style.marginLeft = "0px";
    }
    return (
      <div style={{ fontFamily: "'Cairo', sans-serif" }}>
        <BrowserRouter>
          <Switch>
            <Route path="/login" name="Login Page" component={Login} />
            <Route path="/registeration" name="Login Page" component={SignUp} />
            <Route path='/forget-password' name='forget pass' component={ResetPass} />
            <Route path='/reset-password' name='forget pass' component={ResetPass} />
            <Route path="/" name="Home" component={Layout} />
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    lang: state.login.language
  }
}
export default connect(mapStateToProps, null)(App);